/// <reference path="./services/auth.service.js" />

module.exports = angular.module(
    'bahabot',
    [
        'ngRoute',
        'ngResource',
        'ryTooltip',
        'flatpickr',
        'chartJS',
        'monaco',
        'ryModal'
    ]
);

/**
 * @param {angular.IRootScopeService} $rootScope
 * @param {angular.ILocationService} $location
 * @param {angular.IRouteProvider} $route
 * @param {AuthService} AuthService
 */
function bahabotRunBlock($rootScope, $location, $route, AuthService) {
    let initialRouteHandled = false;

    $rootScope.$on('$routeChangeStart', function (event, next) {
        if (!initialRouteHandled) {
            event.preventDefault();

            AuthService.check().finally(() => {
                initialRouteHandled = true;

                const loggedIn = AuthService.isLoggedIn();

                if ((next.originalPath === '/login' || next.originalPath === '/') && loggedIn) {
                    $location.path('/dashboard');
                } else if (next.requiresAuth && !loggedIn) {
                    $location.path('/login');
                } else {
                    $route.reload(); // resume the original route
                }

                $rootScope.$applyAsync();
            });

            return;
        }

        // Subsequent route changes
        const loggedIn = AuthService.isLoggedIn();

        if ((next.originalPath === '/login' || next.originalPath === '/') && loggedIn) {
            event.preventDefault();
            $location.path('/dashboard');
        }

        if (next.requiresAuth && !loggedIn) {
            event.preventDefault();
            $location.path('/login');
        }
    });
}

module.exports.run(bahabotRunBlock);

module.exports.controller('RouteLayoutController', ['LayoutService', 'AuthService', '$route', '$scope', function(LayoutService, AuthService, $route, $scope) {
    $scope.flexLayout = $route.current?.$$route?.flexLayout;

    // must use login layout
    if (!AuthService.isLoggedIn()) {
        LayoutService.useLogin();
        return
    }

    const layout = $route.current?.layout ?? 'login';
    if (layout === 'login') LayoutService.useLogin()
    else LayoutService.useDashboard()
}]);

// Set up routes
/**
 * @param {angular.route.IRouteProvider} $routeProvider
 * @param {angular.ILocationProvider} $locationProvider
 */
function bahabotConfig($routeProvider, $locationProvider) {
    $routeProvider
        .when('/', { redirectTo: '/login' })
        .when('/login', {
            template: '<bb-login></bb-login>',
            requiresAuth: false,
            controller: 'RouteLayoutController',
            layout: 'login',
            resolve: {
                oauthConfig: function($http) {
                    return $http.get('/api/public/oauth2_config').then(function(res) {
                        return res.data.data;
                    });
                }
            },
        })
        .when('/chat', {
            template: '<bb-chat></bb-chat>',
            requiresAuth: false,
            controller: 'RouteLayoutController',
            layout: 'login',
            flexLayout: true,
        })
        .when('/dashboard', {
            template: '',
            requiresAuth: true,
            redirectTo: '/dashboard/home',
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/home', {
            template: '<bb-dashboard></bb-dashboard>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/settings', {
            template: '<bb-settings></bb-settings>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/commands', {
            template: '<bb-commands></bb-commands>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/discord', {
            template: '<bb-discord></bb-discord>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/commands/create', {
            template: '<bb-commands-editor></bb-commands-editor>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/commands/edit/:id', {
            template: '<bb-commands-editor></bb-commands-editor>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/commands/executions/:commandId', {
            template: '<bb-command-executions></bb-command-executions>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/commands/executions/logs/:executionId', {
            template: '<bb-command-execution-logs></bb-command-execution-logs>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/activities', {
            template: '<bb-activities></bb-activities>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/accounts', {
            template: '<bb-accounts></bb-accounts>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/docs', {
            template: '<bb-docs></bb-docs>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/badwords', {
            template: '<bb-badwords></bb-badwords>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/words', {
            template: '<bb-words></bb-words>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/tagged-messages', {
            template: '<bb-tagged-messages></bb-tagged-messages>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/dashboard/logs', {
            template: '<bb-logs></bb-logs>',
            requiresAuth: true,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .when('/404', {
            template: '<div class="p-6 font-sans text-white"><h1 class="text-2xl">Oh nyo!</h1><br>The requested page could not be found.</div>',
            requiresAuth: false,
            controller: 'RouteLayoutController',
            layout: 'dashboard',
        })
        .otherwise({ redirectTo: '/404' });

    $locationProvider.html5Mode(true);
}

/**
 * @param {angular.IQService} $q
 * @param {angular.ILocationService} $location
 * @returns {angular.IHttpInterceptor}
 */
function bahabotInterceptor($q, $location) {
    return {
        /**
         * @param {angular.IRequestConfig} config
         * @returns {angular.IRequestConfig|angular.IPromise<angular.IRequestConfig>}
         */
        request: function(config) {
            return config;
        },

        /**
         * @param {angular.IHttpResponse<any>} response
         * @returns {angular.IHttpResponse<any>|angular.IPromise<angular.IHttpResponse<any>>}
         */
        response: function(response) {
            return response;
        },

        /**
         * @param {angular.IHttpPromiseCallbackArg<any>} rejection
         * @returns {angular.IPromise<any>}
         */
        responseError: function(rejection) {
            console.log(rejection);
            if (rejection.status === 401 && rejection.data && rejection.data.code === 'unauthenticated') {
                window.location.href = '/login'; // hard set instead of $location service, better to force reload the app here
            }

            return $q.reject(rejection);
        }
    };
}

module.exports.factory('bahabotInterceptor', ['$q', '$location', bahabotInterceptor]);
module.exports.config(['$routeProvider', '$locationProvider', bahabotConfig]);
module.exports.config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('bahabotInterceptor')
}])
